export const remove = require("../assets/remove-32.png");
export const removeItem = require("../assets/remove-30.png");
export const addNew = require("../assets/add-new-30.png");
